/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentProfilePagedData } from '../../models/student-profile-paged-data';

export interface GetStudentProfilesForSchoolClass$Params {
  schoolClassId: string;
  PageNumber?: number;
  PageSize?: number;
}

export function getStudentProfilesForSchoolClass(http: HttpClient, rootUrl: string, params: GetStudentProfilesForSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfilePagedData>> {
  const rb = new RequestBuilder(rootUrl, getStudentProfilesForSchoolClass.PATH, 'get');
  if (params) {
    rb.path('schoolClassId', params.schoolClassId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentProfilePagedData>;
    })
  );
}

getStudentProfilesForSchoolClass.PATH = '/schoolclass/{schoolClassId}/studentprofile';
